module.exports = __webpack_public_path__ + "static/media/btn6.4db5e483.png";